import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgIdentityVerificationRejectedOrInUse(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M89.294 31.75H19.275c-2.75 0-4.978 2.166-4.978 4.838v46.55c0 2.672 2.229 4.838 4.978 4.838h70.02c2.749 0 4.978-2.166 4.978-4.838v-46.55c0-2.672-2.23-4.838-4.979-4.838Z"
        fill="#F1F5F9"
      />
      <path
        d="M18.979 32h70.018c2.749 0 4.979 2.167 4.979 4.838v6.695H14v-6.695C14 34.168 16.23 32 18.979 32Z"
        fill="#78B441"
      />
      <path
        d="M13.497 80.864V43.13a.8.8 0 1 1 1.6 0v37.735c0 3.465 2.896 6.311 6.518 6.312h58.03a.8.8 0 0 1 0 1.6h-58.03c-4.463 0-8.118-3.52-8.118-7.912Z"
        fill="#0F172A"
      />
      <path
        d="m20.373 51.96-.01 27.16c0 1.603 1.337 2.903 2.986 2.903l24.087.009c1.65 0 2.987-1.299 2.988-2.902l.01-27.16c0-1.603-1.337-2.903-2.986-2.904l-24.087-.008c-1.65 0-2.987 1.299-2.988 2.902Z"
        fill="#A6DBCB"
      />
      <path
        d="M26.185 76.433c0-4.693 3.914-8.486 8.743-8.486 4.83 0 8.732 3.803 8.732 8.495v5.71H26.185v-5.72ZM34.928 66.999c2.683 0 4.859-2.114 4.859-4.722 0-2.608-2.176-4.722-4.86-4.722-2.683 0-4.858 2.114-4.858 4.722 0 2.608 2.175 4.722 4.859 4.722Z"
        fill="#007A5F"
      />
      <path d="M86.964 51.105a.8.8 0 0 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h30.648Z" fill="#78B441" />
      <path
        d="M75.254 78.497a.8.8 0 1 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h18.938ZM86.964 72.808a.8.8 0 0 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h30.648ZM86.964 67.128a.8.8 0 0 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h30.648ZM86.964 56.794a.8.8 0 0 1 0 1.6H56.316a.8.8 0 1 1 0-1.6h30.648Z"
        fill="#B3C0D0"
      />
      <path
        d="M94.273 71.74c6.747 0 12.217-5.315 12.217-11.872 0-6.557-5.47-11.872-12.217-11.872-6.748 0-12.218 5.315-12.218 11.872 0 6.557 5.47 11.872 12.218 11.872Z"
        fill="#E41E3F"
      />
      <path
        d="M98.883 62.78c.209.203.328.484.328.774 0 .29-.12.571-.328.784-.22.203-.498.32-.807.32a1.13 1.13 0 0 1-.796-.32l-2.997-2.912-2.998 2.912c-.428.416-1.174.416-1.603 0a1.115 1.115 0 0 1-.338-.784c0-.29.12-.57.338-.774l2.998-2.912-2.998-2.913a1.06 1.06 0 0 1-.338-.783c0-.3.12-.571.338-.774.429-.416 1.175-.416 1.603 0l2.998 2.912 2.997-2.912c.418-.416 1.175-.416 1.603 0 .209.203.328.483.328.774 0 .29-.12.58-.328.783l-2.997 2.913 2.997 2.912Z"
        fill="#fff"
      />
    </svg>
  )
}
export default wrapIllustration(SvgIdentityVerificationRejectedOrInUse)
